import { render, staticRenderFns } from "./EstelLogo.vue?vue&type=template&id=076bb7e3&scoped=true&"
var script = {}
import style0 from "./EstelLogo.vue?vue&type=style&index=0&id=076bb7e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bb7e3",
  null
  
)

export default component.exports